module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M14 10c-1.106 0-2 .894-2 2v6c0 1.106.894 2 2 2h6c1.106 0 2-.894 2-2s-.894-2-2-2h-4v-4c0-1.106-.894-2-2-2zm16.586-8.584l-3.218 3.218C24.39 1.754 20.192 0 16 0 7.178 0 0 7.178 0 16s7.178 16 16 16c7.14 0 13.302-4.594 15.336-11.43a2 2 0 1 0-3.834-1.14C25.978 24.554 21.356 28 16 28 9.382 28 4 22.618 4 16S9.382 4 16 4c3.118 0 6.332 1.302 8.57 3.432l-3.156 3.154c-.782.782-.52 1.414.586 1.414h9c.552 0 1-.446 1-.998v-9c0-1.106-.632-1.368-1.414-.586z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/history-1.js
// module id = 1173
// module chunks = 14